/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import profilePhoto from "../../assets/profile_photo.svg";
import { APIContext } from "../../api/api";
import HelmetLayout from "../../components/HelmetLayout";
import { PulseLoader } from "react-spinners";

function AISections() {
  const [sectionList, setSectionList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);

  const { listOfAllAISections, syncAISections } = useContext(APIContext);

  useEffect(() => {
    listOfAllAISections()
      .then((sections) => {
        console.log(sections);
        setSectionList(sections);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error.message);
        setLoading(false);
      });
  }, []);

  const handleSyncSections = async () => {
    setSyncing(true);
    try {
      await syncAISections();
      // Refresh the list after syncing
      const sections = await listOfAllAISections();
      setSectionList(sections);
      alert("Sections synced successfully!");
    } catch (error) {
      console.error("Error syncing sections:", error);
      alert("Error syncing sections: " + (error.message || "Unknown error"));
    } finally {
      setSyncing(false);
    }
  };

  if (loading) {
    return (
      <>
        <HelmetLayout title="AI Sections" />
        <div className="font-Inter flex-1 h-screen overflow-y-scroll bg-white items-start p-7 flex justify-center items-center">
          <PulseLoader size={15} color="#5CBD20" />
        </div>
      </>
    );
  }

  return (
    <>
      <HelmetLayout title="AI Sections" />
      <div className="font-Inter flex-1 h-screen overflow-y-scroll bg-white items-start p-7">
        <div className="flex flex-col items-center justify-start">
          <div className="w-full flex flex-row justify-between mb-6">
            <h1 className="text-[32px]">AI Sections</h1>
            <img
              src={profilePhoto}
              className="mr-4 h-9"
              alt="user-profile-img"
            />
          </div>

          {/* Card Section */}
          <div className="w-full flex justify-start items-center m-5 ml-0 gap-[14px]">
            <div className="rounded-[29px] shadow-card-box-shadow">
              <div className="w-[255px] h-[100px] flex flex-col justify-center items-center">
                <div className="flex flex-col items-start">
                  <h1 className="font-bold">{sectionList.length}</h1>
                  <p>Total AI Sections</p>
                </div>
              </div>
            </div>
          </div>

          {/* Add New Section Button */}
          <div className="w-full flex justify-between items-center">
            <h1 className="text-[#121213] text-2xl">All AI Sections</h1>
            <div className="flex gap-[10px]">
              <button
                onClick={handleSyncSections}
                disabled={syncing}
                className="rounded-[20px] bg-[#F5F7FC] px-4 py-3 items-center text-[14px] text-center disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {syncing ? "Syncing..." : "Sync Sections"}
              </button>
              <Link to="/ai-sections/add">
                <button className="rounded-[20px] bg-[#F5F7FC] px-4 py-3 items-center text-[14px] text-center">
                  Add New
                </button>
              </Link>
            </div>
          </div>

          {/* Sections List Section */}
          <div className="w-full flex flex-row flex-wrap justify-start items-center gap-5 mt-10">
            {sectionList.length === 0 ? (
              <div className="w-full text-center py-10">
                <p className="text-gray-500">No AI sections found</p>
              </div>
            ) : (
              sectionList.map((section) => {
                return (
                  <div
                    key={section.section_id}
                    className="flex flex-col"
                    title={section.section_name}
                  >
                    <Link to={`/ai-sections/${section.section_id}`}>
                      <img
                        className="w-[250px] h-[200px] rounded-[9px] object-cover"
                        src={section.section_thumbnail || "https://via.placeholder.com/250x200"}
                        alt="section-thumbnail"
                      />
                    </Link>
                    <div className="flex justify-between items-center mt-2 px-1">
                      <p className="text-sm text-gray-700 truncate w-[200px]">
                        {section.section_name}
                      </p>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AISections;
